// import axios from "axios";
import ProductData from './Full-PDP-Product-Data.json'

const masterProductData = new Promise((resolve) => {

    resolve({products: ProductData});

});

class ProductApi {

    constructor() {


    }

    async getProductDataBySlug(slug) {
        const {products} = await masterProductData;
        const product = products.find(x => x.key === slug);
        // console.log("matching", slug, "found", product)
        if (!product) return null;
        return product;
    }

}

export default ProductApi;